// extracted by mini-css-extract-plugin
export default {"preChatImage":"OscPreChatHeader_preChatImage__GZ7Lc"};